import {
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { KeyValue, WebformService } from '@app/services/webform.service';
import { DrupalService } from '@app/services/drupal.service';
import { Subscription, debounceTime, distinctUntilChanged } from 'rxjs';

@Component({
  standalone: false,
  selector: 'webform-dsebox',
  templateUrl: './dsebox.component.html',
  styleUrls: ['./dsebox.component.scss'],
})
export class DseboxComponent implements OnInit, OnDestroy {
  @Input() field!: any;
  title: string = 'Title loading from API...';
  text: string = 'Text loading from API...';

  #dataSub!: Subscription;

  readonly #webform = inject(WebformService);
  readonly #route = inject(DrupalService);
  readonly #cdr = inject(ChangeDetectorRef);

  async ngOnInit(): Promise<void> {
    if (this.field['#title_override'] && this.field['#text_override']) {
      this.title = this.field['#title_override'];
      this.text = this.field['#text_override'];
      return;
    }
    const endpoint: string = this.field['#endpoint'];
    const cp_tkid: string = this.field['#contact_point_tkid'];
    const case_type: string = this.field['#case_type'];
    const dse_interpretation: string = this.field['#dse_interpretation'];
    const lang = this.#route.language();

    this.#dataSub = this.#webform.formData
      .pipe(distinctUntilChanged(), debounceTime(500))
      .subscribe(async (data: KeyValue) => {
        if (!data[`${this.#webform.formId}--leadapi_pd_address`]?.postal_code) {
          return;
        }
        const plz: string =
          data[`${this.#webform.formId}--leadapi_pd_address`].postal_code;

        const dseData: any = await this.#webform.call(
          `${endpoint}?contact_point_tkid=${cp_tkid}&case_type=${case_type}&dse_interpretation=${dse_interpretation}&language=${lang}&postalcode=${plz}`
        );

        dseData?.purposes.forEach((p: any) => {
          if (p?.type === 'NO_CHOICE') {
            this.title = p.title;
            this.text = p.description;
          }
        });

        this.#cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    if (this.#dataSub) this.#dataSub.unsubscribe();
  }
}
